(function () {
  'use strict';

  function boot() {
    var root = document.querySelector('[data-flexlead-root]');
    if (!root) return;

    var modal = root.querySelector('[data-flexlead-modal]');
    var panel = root.querySelector('.flexlead__panel');
    var form = root.querySelector('form');
    var result = root.querySelector('[data-flexlead-result]');
    var step1 = root.querySelector('[data-flexlead-step="1"]');
    var step2 = root.querySelector('[data-flexlead-step="2"]');
    var next = root.querySelector('[data-flexlead-next]');
    var back = root.querySelector('[data-flexlead-back]');
    var submit = root.querySelector('[data-flexlead-submit]');
    var fill = root.querySelector('[data-flexlead-progress-fill]');
    var label1 = root.querySelector('[data-flexlead-progress-label="1"]');
    var label2 = root.querySelector('[data-flexlead-progress-label="2"]');
    var goalsField = root.querySelector('[data-flexlead-goals]');
    var goalCount = root.querySelector('[data-flexlead-goal-count]');
    var defaultInterest = root.getAttribute('data-flexlead-default-interest') || '';
    var pendingKey = 'flexlearn_lead_pending_v3';
    var scrollKey = 'flexlearn_lead_scroll_v3';
    var goalsKey = 'flexlearn_lead_goals_v3';
    var firstTouchKey = 'flexlearn_attribution_first_v1';
    var lastTouchKey = 'flexlearn_attribution_last_v1';
    var lastFocus = null;
    var MAX_GOALS = 3;

    function safeGetSession(key) { try { return window.sessionStorage.getItem(key); } catch (e) { return null; } }
    function safeSetSession(key, value) { try { window.sessionStorage.setItem(key, value); } catch (e) {} }
    function safeRemoveSession(key) { try { window.sessionStorage.removeItem(key); } catch (e) {} }
    function safeGetLocal(key) { try { return window.localStorage.getItem(key); } catch (e) { return null; } }
    function safeSetLocal(key, value) { try { window.localStorage.setItem(key, value); } catch (e) {} }
    function uid() { return 'fl_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10); }
    function parseJson(value, fallback) { try { return JSON.parse(value); } catch (e) { return fallback; } }

    function currentAttribution() {
      var params = new URLSearchParams(window.location.search);
      var braid = params.get('gbraid') || params.get('wbraid') || '';
      return {
        landing_page: window.location.pathname + window.location.search,
        referrer: document.referrer || '',
        timestamp_utc: new Date().toISOString(),
        utm_source: params.get('utm_source') || '',
        utm_medium: params.get('utm_medium') || '',
        utm_campaign: params.get('utm_campaign') || '',
        utm_content: params.get('utm_content') || '',
        utm_term: params.get('utm_term') || '',
        gclid: params.get('gclid') || '',
        google_braid: braid,
        fbclid: params.get('fbclid') || '',
        msclkid: params.get('msclkid') || '',
        ttclid: params.get('ttclid') || '',
        li_fat_id: params.get('li_fat_id') || ''
      };
    }

    function hasAttributionSignal(touch) {
      return !!(touch.utm_source || touch.utm_medium || touch.utm_campaign || touch.utm_content || touch.utm_term ||
        touch.gclid || touch.google_braid || touch.fbclid || touch.msclkid || touch.ttclid || touch.li_fat_id || touch.referrer);
    }

    function rememberAttribution() {
      var now = currentAttribution();
      var first = parseJson(safeGetLocal(firstTouchKey) || 'null', null);
      var last = parseJson(safeGetLocal(lastTouchKey) || 'null', null);
      if (!first) {
        first = now;
        safeSetLocal(firstTouchKey, JSON.stringify(first));
      }
      if (!last || hasAttributionSignal(now)) {
        last = now;
        safeSetLocal(lastTouchKey, JSON.stringify(last));
      }
      return { first: first || now, last: last || now };
    }

    var attribution = rememberAttribution();

    function cleanValue(value) {
      return value == null || value === '' ? 'Not provided' : String(value);
    }

    function setMeta(key, value) {
      var el = root.querySelector('[data-flexlead-meta="' + key + '"]');
      if (el) el.value = cleanValue(value);
    }

    function visitorTimezone() {
      try { return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Not provided'; } catch (e) { return 'Not provided'; }
    }

    function visitorLocalTime() {
      try {
        return new Intl.DateTimeFormat(undefined, {
          year: 'numeric', month: 'short', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit',
          timeZoneName: 'short'
        }).format(new Date());
      } catch (e) { return new Date().toString(); }
    }

    function deviceCategory() {
      if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) return 'Mobile';
      if (window.matchMedia && window.matchMedia('(max-width: 989px)').matches) return 'Tablet';
      return 'Desktop';
    }

    function emailDomain() {
      var input = root.querySelector('#FlexLeadEmail');
      var email = input ? String(input.value || '').trim().toLowerCase() : '';
      var at = email.lastIndexOf('@');
      return at > 0 && at < email.length - 1 ? email.slice(at + 1) : '';
    }

    function populateLeadIntelligence(eventId) {
      attribution = rememberAttribution();
      var first = attribution.first || {};
      var last = attribution.last || {};

      setMeta('submission_page', window.location.pathname + window.location.search);
      setMeta('first_landing_page', first.landing_page);
      setMeta('first_referrer', first.referrer || 'Direct / unknown');
      setMeta('last_referrer', last.referrer || first.referrer || 'Direct / unknown');

      setMeta('last_utm_source', last.utm_source || first.utm_source);
      setMeta('last_utm_medium', last.utm_medium || first.utm_medium);
      setMeta('last_utm_campaign', last.utm_campaign || first.utm_campaign);
      setMeta('last_utm_content', last.utm_content || first.utm_content);
      setMeta('last_utm_term', last.utm_term || first.utm_term);

      setMeta('first_utm_source', first.utm_source);
      setMeta('first_utm_medium', first.utm_medium);
      setMeta('first_utm_campaign', first.utm_campaign);
      setMeta('first_utm_content', first.utm_content);
      setMeta('first_utm_term', first.utm_term);

      setMeta('gclid', last.gclid || first.gclid);
      setMeta('google_braid', last.google_braid || first.google_braid);
      setMeta('fbclid', last.fbclid || first.fbclid);
      setMeta('msclkid', last.msclkid || first.msclkid);
      setMeta('ttclid', last.ttclid || first.ttclid);
      setMeta('li_fat_id', last.li_fat_id || first.li_fat_id);

      setMeta('browser_language', navigator.language || (navigator.languages && navigator.languages[0]) || 'Not provided');
      setMeta('timezone', visitorTimezone());
      setMeta('visitor_local_time', visitorLocalTime());
      setMeta('submitted_utc', new Date().toISOString());
      setMeta('device', deviceCategory());
      setMeta('email_domain', emailDomain());
      setMeta('event_id', eventId || 'Not provided');
    }

    function selectedGoals() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-flexlead-goal]:checked')).map(function (el) { return el.value; });
    }

    function syncGoals() {
      var goals = selectedGoals();
      if (goalsField) goalsField.value = goals.join(' | ');
      if (goalCount) {
        goalCount.textContent = goals.length + ' / ' + MAX_GOALS + ' selected';
        goalCount.classList.toggle('is-max', goals.length === MAX_GOALS);
      }
      root.querySelectorAll('[data-flexlead-goal]').forEach(function (input) {
        input.disabled = goals.length >= MAX_GOALS && !input.checked;
      });
      return goals;
    }

    function saveGoals() {
      var goals = syncGoals();
      safeSetSession(goalsKey, JSON.stringify(goals));
      return goals;
    }

    function restoreGoals() {
      var saved = parseJson(safeGetSession(goalsKey) || '[]', []);
      if (!Array.isArray(saved)) saved = [];
      if (!saved.length && defaultInterest) saved = [defaultInterest];
      root.querySelectorAll('[data-flexlead-goal]').forEach(function (input) {
        input.checked = saved.indexOf(input.value) !== -1;
      });
      syncGoals();
    }

    function addGoal(value) {
      if (!value) return;
      var goals = selectedGoals();
      if (goals.indexOf(value) !== -1) return;
      if (goals.length >= MAX_GOALS) return;
      var inputs = root.querySelectorAll('[data-flexlead-goal]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value === value) {
          inputs[i].checked = true;
          break;
        }
      }
      saveGoals();
    }

    function openModal(opts) {
      opts = opts || {};
      lastFocus = document.activeElement;
      if (opts.interest) addGoal(opts.interest);
      // Always show the goal step so visitors can add up to 2 more priorities.
      if (step1 && step2) showStep(1);
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('flexlead-lock');
      window.requestAnimationFrame(function () {
        modal.classList.add('is-open');
        var focusTarget = root.querySelector('[data-flexlead-success] [data-flexlead-close]') || root.querySelector('[data-flexlead-goal]:checked') || root.querySelector('input, button, select');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      });
      pushData('flexlearn_form_opened', { goals: selectedGoals().join(' | '), goal_count: selectedGoals().length });
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('flexlead-lock');
      window.setTimeout(function () { modal.hidden = true; }, 220);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
    }

    function pushData(eventName, extras) {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: eventName, source_page: window.location.pathname };
      if (extras) Object.keys(extras).forEach(function (k) { payload[k] = extras[k]; });
      window.dataLayer.push(payload);
    }

    function showStep(n) {
      if (!step1 || !step2) return;
      step1.hidden = n !== 1;
      step2.hidden = n !== 2;
      if (fill) fill.style.width = n === 1 ? '50%' : '100%';
      if (label1) label1.classList.toggle('is-active', n === 1);
      if (label2) label2.classList.toggle('is-active', n === 2);
      if (n === 2) {
        var goals = saveGoals();
        pushData('flexlearn_form_step_2', { goals: goals.join(' | '), goal_count: goals.length });
      }
    }

    function validateGoals() {
      var goals = selectedGoals();
      if (goals.length < 1) {
        var firstGoal = root.querySelector('[data-flexlead-goal]');
        if (firstGoal) firstGoal.focus();
        if (goalCount) {
          goalCount.textContent = 'Choose at least 1 priority';
          goalCount.classList.add('has-error');
          window.setTimeout(function () { goalCount.classList.remove('has-error'); syncGoals(); }, 1800);
        }
        return false;
      }
      if (goals.length > MAX_GOALS) return false;
      return true;
    }

    function validate(container) {
      if (!container) return true;
      var fields = container.querySelectorAll('input, select, textarea');
      for (var i = 0; i < fields.length; i++) {
        if (fields[i].hasAttribute('data-flexlead-goal')) continue;
        if (!fields[i].checkValidity()) {
          fields[i].reportValidity();
          return false;
        }
      }
      return true;
    }

    function trackLeadOnce() {
      if (!result || result.getAttribute('data-success') !== 'true') return;
      var pending = parseJson(safeGetSession(pendingKey) || 'null', null);
      var eventId = pending && pending.eventId ? pending.eventId : uid();
      var sentKey = 'flexlearn_lead_sent_v4:' + eventId;
      if (safeGetSession(sentKey) === '1') {
        window.__openAILeadTracked = true;
        window.__openAILeadEventId = eventId;
        window.__openAILeadPending = false;
        return;
      }

      var goals = pending && Array.isArray(pending.goals) ? pending.goals : parseJson(safeGetSession(goalsKey) || '[]', []);
      var goalsText = goals.length ? goals.join(' | ') : (defaultInterest || 'Website contact');
      var firstTouch = (pending && pending.firstTouch) || attribution.first || {};
      var lastTouch = (pending && pending.lastTouch) || attribution.last || {};

      /* Google/GTM analytics event can be recorded regardless of OpenAI consent. */
      if (!window.__flexlearnLeadDataLayerPushed) {
        pushData('flexlearn_lead_created', {
          event_id: eventId,
          lead_type: 'website_contact',
          goals: goalsText,
          goal_count: goals.length,
          utm_source: lastTouch.utm_source || firstTouch.utm_source || '',
          utm_medium: lastTouch.utm_medium || firstTouch.utm_medium || '',
          utm_campaign: lastTouch.utm_campaign || firstTouch.utm_campaign || '',
          first_utm_source: firstTouch.utm_source || '',
          first_utm_medium: firstTouch.utm_medium || '',
          first_utm_campaign: firstTouch.utm_campaign || '',
          first_landing_page: firstTouch.landing_page || '',
          original_referrer: firstTouch.referrer || ''
        });
        window.__flexlearnLeadDataLayerPushed = true;
      }

      window.__openAILeadEventId = eventId;

      /*
       * OpenAI explicitly does not replay events blocked while consent is false.
       * Therefore do NOT mark the lead as sent until Shopify measurement consent
       * is actually granted. Keep the pending lead and retry on consent grant.
       */
      if (window.__openAIConsentGranted !== true) {
        window.__openAILeadPending = true;
        window.__openAILeadTracked = false;
        return;
      }

      if (typeof window.oaiq !== 'function') {
        window.__openAILeadPending = true;
        window.__openAILeadTracked = false;
        return;
      }

      window.oaiq('measure', 'lead_created', { type: 'customer_action' }, { event_id: eventId });
      window.__openAILeadTracked = true;
      window.__openAILeadPending = false;
      safeSetSession(sentKey, '1');
      safeRemoveSession(pendingKey);
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-flexlearn-demo-open], a[href="#flexlearn-demo"]');
      if (!trigger) return;
      event.preventDefault();
      var interest = trigger.getAttribute('data-flexlearn-interest') || defaultInterest;
      openModal({ interest: interest });
    });

    root.querySelectorAll('[data-flexlead-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
    if (panel) panel.addEventListener('click', function (e) { e.stopPropagation(); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !modal.hidden) closeModal(); });

    root.querySelectorAll('[data-flexlead-goal]').forEach(function (input) {
      input.addEventListener('change', function () {
        var goals = selectedGoals();
        if (goals.length > MAX_GOALS) {
          input.checked = false;
        }
        saveGoals();
      });
    });

    if (next) next.addEventListener('click', function () {
      if (!validateGoals()) return;
      saveGoals();
      showStep(2);
      var first = step2 && step2.querySelector('input');
      if (first) window.setTimeout(function () { first.focus(); }, 40);
    });
    if (back) back.addEventListener('click', function () { showStep(1); });

    if (form) form.addEventListener('submit', function (event) {
      if (step2 && step2.hidden) {
        event.preventDefault();
        if (validateGoals()) showStep(2);
        return;
      }
      if (!validateGoals() || !validate(step2)) { event.preventDefault(); return; }

      var eventId = uid();
      var goals = saveGoals();
      populateLeadIntelligence(eventId);
      safeSetSession(scrollKey, String(window.scrollY || 0));
      safeSetSession(pendingKey, JSON.stringify({
        eventId: eventId,
        goals: goals,
        ts: Date.now(),
        source: window.location.pathname,
        firstTouch: attribution.first,
        lastTouch: attribution.last
      }));
      if (submit) { submit.disabled = true; submit.textContent = 'Sending…'; }
    });

    restoreGoals();
    populateLeadIntelligence('Not provided');

    var hasSuccess = result && result.getAttribute('data-success') === 'true';
    var hasErrors = result && result.getAttribute('data-errors') === 'true';
    if (hasSuccess || hasErrors) {
      var savedScroll = parseInt(safeGetSession(scrollKey) || '', 10);
      if (!Number.isNaN(savedScroll)) window.requestAnimationFrame(function () { window.scrollTo(0, savedScroll); });
      safeRemoveSession(scrollKey);
      if (hasErrors) showStep(2);
      openModal();
      if (window.location.hash) {
        try { window.history.replaceState(null, document.title, window.location.pathname + window.location.search); } catch (e) {}
      }
    } else if (window.location.hash === '#flexlearn-demo') {
      openModal({ interest: defaultInterest });
      try { window.history.replaceState(null, document.title, window.location.pathname + window.location.search); } catch (e) {}
    }

    window.addEventListener('flexlearn:openai-consent', function (event) {
      if (event && event.detail && event.detail.granted === true) trackLeadOnce();
    });

    trackLeadOnce();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
